import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MdOutlineWarning, MdOutlineFiberNew } from 'react-icons/md';
import officeService from '../../../services/officeService';
import { isExternalUser } from '../../../application-center/login-center/lib/authentication';
import styles from './style.module.scss';

export const Announcement = ({ /*history,*/ newScheduleIndicator, showSeatCTA }) => {
  const [guideURL, setGuideURL] = useState('');
  const [documentations, setDocumentations] = useState([]);
  // const [dob, setDOB] = useState('1900-01-01');
  const [showRLExpiryNote, setShowRLExpiryNote] = useState(false);

  const { claimLeaves } = useSelector(s => s.claimLeaves);

  useEffect(() => {
    officeService.getGuideURL().then(url => setGuideURL(url));
    officeService.getDocumentationsURL().then(docs => setDocumentations(docs));
    // const user = JSON.parse(localStorage.getItem('User')) || {};
    // setDOB(user.Birthdate || '1900-01-01');
  }, []);

  useEffect(() => {
    // find claimLeaves that are expiring in this month
    const today = new Date();
    const thisMonth = today.getMonth() + 1;
    const thisYear = today.getFullYear();
    const expiringRL = claimLeaves?.filter(c => {
      const expiryDate = new Date(c.ExpiryDate);
      return expiryDate.getMonth() + 1 === thisMonth && expiryDate.getFullYear() === thisYear;
    });
    if (expiringRL.length > 0) {
      setShowRLExpiryNote(true);
    }
  }, [claimLeaves]);

  // const handleLinkClick = path => {
  //   history?.push(path);
  // };

  const handleGotoSeatClick = () => {
    showSeatCTA(true);
  };

  return (
    <div className={styles['announcement-section']}>
      {showRLExpiryNote && (
        <div className={styles['alertText']}>
          <MdOutlineWarning /> You have RL/CF leave expiring this month. Please use it before it expires.
        </div>
      )}
      <div>
        <Link to="/absMyAbsences">Absences</Link> | <Link to="/otClaim">OT</Link> |{' '}
        <Link to="/oncallClaim">Oncall</Link> | <Link to="/absMyClaimedLeaves">RL/CashOut</Link>
      </div>

      {!isExternalUser() && (
        <>
          <div>
            <a
              href="https://isoftstonenae.sharepoint.com/:w:/s/MyIsoftstone/EXYByMlBQ4RLieNArN2khh8BKaAAp3MuqPKkb86VWFTh1Q?e=2CdqB6"
              target="_blank"
              rel="noreferrer"
            >
              MyESS Guide
            </a>
            {guideURL && (
              <>
                {' '}
                |{' '}
                <a href={guideURL} target="_blank" rel="noreferrer" className={styles['guideText']}>
                  {localStorage.getItem('role') === 'lead' ? 'Team Lead' : 'Admin'} Guide
                </a>
              </>
            )}
          </div>
          {documentations?.map((doc, i) => {
            return (
              <div key={i}>
                <a href={doc.URL} target="_blank" rel="noreferrer" className={styles['guideText']}>
                  {doc.Title}
                </a>
              </div>
            );
          })}

          {/* {dob === '1900-01-01' && (
        <div>
          Please update your birthdate at{' '}
          <a className="link" onClick={() => handleLinkClick('/profile')}>
            Profile
          </a>
        </div>
      )} */}

          <div className="link" onClick={handleGotoSeatClick}>
            Seat Information
            {newScheduleIndicator && <MdOutlineFiberNew className={styles['schedule-updated']} size={30} />}
          </div>
        </>
      )}
    </div>
  );
};
